/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import settingPage from './setting-page';

import Accordion from 'shared/ui/components/Accordion.vue';
import EmailTemplatePicker from 'shared/ui/components/form-components/pickers/EmailTemplatePicker.vue';

const __vue_script__ = {
    name: 'Communication',

    components: {
        Accordion,
        EmailTemplatePicker,
    },

    mixins: [settingPage],

    data() {
        return {
            templates: [],
            emailMeetingPlannerNotification: null,
            emailMeetingCreated: null,
            emailMeetingUpdated: null,
            emailMeetingCancelled: null,
            emailMeetingNewInvite: null,
            emailMeetingRejectedInvite: null,
            emailMeetingStatusUpdate: null,
            meetingEmailsCc: []
        };
    },

    methods: {
        async init() {
            await this.loadTemplates();
            this.emailMeetingPlannerNotification = this.settings.email_meeting_planner_notification;
            this.emailMeetingCreated = this.settings['email_meeting_created'];
            this.emailMeetingUpdated = this.settings['email_meeting_updated'];
            this.emailMeetingCancelled = this.settings['email_meeting_cancelled'];
            this.emailMeetingStatusUpdate = this.settings['email_meeting_status_update'];
            this.emailMeetingNewInvite = this.settings['email_meeting_new_invite'];
            this.emailMeetingRejectedInvite = this.settings['email_meeting_rejected_invite'];
            this.meetingEmailsCc = this.settings['meeting_emails_cc'];
        },

        async loadTemplates() {
            try {
                this.templates = await this.$services.emails.getEmailTemplates(this.event._id, { onlyActive: true, cached: true });
            } catch (error) {
                console.error('[Communication] Could not load email templates:', error.message);
            }
        },

        save() {
            this.$emit('save', {
                'email_meeting_planner_notification': this.emailMeetingPlannerNotification,
                'email_meeting_created': this.emailMeetingCreated,
                'email_meeting_updated': this.emailMeetingUpdated,
                'email_meeting_cancelled': this.emailMeetingCancelled,
                'email_meeting_new_invite': this.emailMeetingNewInvite,
                'email_meeting_rejected_invite': this.emailMeetingRejectedInvite,
                'email_meeting_status_update': this.emailMeetingStatusUpdate,
                'meeting_emails_cc': this.meetingEmailsCc
            });
        },

        getLabel(field) {
            return this.registry[field]?.label || '';
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    {
      ref: "form",
      staticClass: "communication",
      attrs: { tag: "form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
    },
    [
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("meetings.settings.communication.title"))),
      ]),
      _c("accordion", {
        attrs: {
          "headers-i18n-prefix": "meetings.settings.communication",
          "default-open-item": "meetings",
          animated: true,
          "unlimited-height": true,
          slim: true,
        },
        scopedSlots: _vm._u([
          {
            key: "meeting_planner",
            fn: function (ref) {
              return [
                _c("validation-provider", {
                  attrs: { slim: true, name: "meeting_emails_cc" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c("meta-control", {
                              attrs: {
                                name: "meeting_emails_cc",
                                templates: _vm.templates,
                                control: _vm.registry["meeting_emails_cc"],
                                errors: errors,
                                event: _vm.event,
                              },
                              model: {
                                value: _vm.meetingEmailsCc,
                                callback: function ($$v) {
                                  _vm.meetingEmailsCc = $$v
                                },
                                expression: "meetingEmailsCc",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("validation-provider", {
                  attrs: {
                    slim: true,
                    name: "email_meeting_planner_notification",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "email_meeting_planner_notification",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getLabel(
                                          "email_meeting_planner_notification"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("email-template-picker", {
                                  attrs: {
                                    name: "email_meeting_planner_notification",
                                    templates: _vm.templates,
                                    "event-id": _vm.event._id,
                                    "show-no-send": true,
                                  },
                                  model: {
                                    value: _vm.emailMeetingPlannerNotification,
                                    callback: function ($$v) {
                                      _vm.emailMeetingPlannerNotification = $$v
                                    },
                                    expression:
                                      "emailMeetingPlannerNotification",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
          },
          {
            key: "meetings",
            fn: function (ref) {
              return [
                _c("validation-provider", {
                  attrs: { slim: true, name: "email_meeting_created" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "email_meeting_created" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getLabel("email_meeting_created")
                                      )
                                    ),
                                  ]
                                ),
                                _c("email-template-picker", {
                                  attrs: {
                                    name: "email_meeting_created",
                                    templates: _vm.templates,
                                    "event-id": _vm.event._id,
                                    "show-no-send": true,
                                  },
                                  model: {
                                    value: _vm.emailMeetingCreated,
                                    callback: function ($$v) {
                                      _vm.emailMeetingCreated = $$v
                                    },
                                    expression: "emailMeetingCreated",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("validation-provider", {
                  attrs: { slim: true, name: "email_meeting_updated" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "email_meeting_updated" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getLabel("email_meeting_updated")
                                      )
                                    ),
                                  ]
                                ),
                                _c("email-template-picker", {
                                  attrs: {
                                    name: "email_meeting_updated",
                                    templates: _vm.templates,
                                    "event-id": _vm.event._id,
                                    "show-no-send": true,
                                  },
                                  model: {
                                    value: _vm.emailMeetingUpdated,
                                    callback: function ($$v) {
                                      _vm.emailMeetingUpdated = $$v
                                    },
                                    expression: "emailMeetingUpdated",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("validation-provider", {
                  attrs: { slim: true, name: "email_meeting_cancelled" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "email_meeting_cancelled" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getLabel("email_meeting_cancelled")
                                      )
                                    ),
                                  ]
                                ),
                                _c("email-template-picker", {
                                  attrs: {
                                    name: "email_meeting_cancelled",
                                    templates: _vm.templates,
                                    "event-id": _vm.event._id,
                                    "show-no-send": true,
                                  },
                                  model: {
                                    value: _vm.emailMeetingCancelled,
                                    callback: function ($$v) {
                                      _vm.emailMeetingCancelled = $$v
                                    },
                                    expression: "emailMeetingCancelled",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("validation-provider", {
                  attrs: { slim: true, name: "email_meeting_status_update" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "email_meeting_status_update",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getLabel(
                                          "email_meeting_status_update"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("email-template-picker", {
                                  attrs: {
                                    name: "email_meeting_status_update",
                                    templates: _vm.templates,
                                    "event-id": _vm.event._id,
                                    "show-no-send": true,
                                  },
                                  model: {
                                    value: _vm.emailMeetingStatusUpdate,
                                    callback: function ($$v) {
                                      _vm.emailMeetingStatusUpdate = $$v
                                    },
                                    expression: "emailMeetingStatusUpdate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
          },
          {
            key: "meetings_requests",
            fn: function (ref) {
              return [
                _c("validation-provider", {
                  attrs: { slim: true, name: "email_meeting_new_invite" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: { for: "email_meeting_new_invite" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getLabel("email_meeting_new_invite")
                                      )
                                    ),
                                  ]
                                ),
                                _c("email-template-picker", {
                                  attrs: {
                                    name: "email_meeting_new_invite",
                                    templates: _vm.templates,
                                    "event-id": _vm.event._id,
                                    "show-no-send": true,
                                  },
                                  model: {
                                    value: _vm.emailMeetingNewInvite,
                                    callback: function ($$v) {
                                      _vm.emailMeetingNewInvite = $$v
                                    },
                                    expression: "emailMeetingNewInvite",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("validation-provider", {
                  attrs: { slim: true, name: "email_meeting_rejected_invite" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "email_meeting_rejected_invite",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getLabel(
                                          "email_meeting_rejected_invite"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("email-template-picker", {
                                  attrs: {
                                    name: "email_meeting_rejected_invite",
                                    templates: _vm.templates,
                                    "event-id": _vm.event._id,
                                    "show-no-send": true,
                                  },
                                  model: {
                                    value: _vm.emailMeetingRejectedInvite,
                                    callback: function ($$v) {
                                      _vm.emailMeetingRejectedInvite = $$v
                                    },
                                    expression: "emailMeetingRejectedInvite",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
          },
        ]),
      }),
      _c("secondary-toolbar", [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "submit" } },
          [_vm._v(_vm._s(_vm.$t("general.save")))]
        ),
      ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/sub-pages/Communication.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__